enum RequestSubtype {
  REPLACEMENT = 'Sustitución',
  FIRSTASSIGNMENT = 'Primera asignación'
}

export default RequestSubtype;
